// ---------------------------------------------------------------------------
// Boardeingabe fuer 501 - Ersatz fuer den Ziffernblock
//
// Sammelt bis zu drei Darts und uebergibt die Summe an submit501Score(). Das
// ist derselbe Weg, den vorher der Ziffernblock genommen hat: Es gibt also
// weiterhin genau EINE Stelle, an der die Spiellogik eine Aufnahme entgegen-
// nimmt - egal ob von Hand, vom Board oder spaeter von der Kamera.
//
// Warum drei Darts einzeln statt einer Summe: Der Ziffernblock kannte nur
// "60". Ob das T20 war oder 20+20+20, wusste niemand. Fuer Statistiken wie
// Trefferquote auf Doppel oder Streuung um die 20 ist genau das aber die
// entscheidende Information - und der Tracker liefert sie ohnehin je Dart.
// ---------------------------------------------------------------------------

const SLOTS = 3;

const zustand = {
  board: null,
  darts: [], // { points, label, xMm, yMm, quelle }
  gewaehlt: null, // Index des Darts, der als naechstes ersetzt wird
  // Darts, die jemand ANDERES wirft - heute der Bot (15.08.2026).
  //
  // Bewusst NICHT in `darts`: Das ist der Eingabepuffer des Menschen. Waeren
  // die Botdarts darin, wuerde boardCommit501() sie als eigene Aufnahme
  // abschicken. Sie liegen deshalb daneben, werden nur angezeigt, und
  // solange sie liegen, nimmt treffer() nichts entgegen.
  fremde: null,
};

function el(id) {
  return document.getElementById(id);
}

function zeichnen() {
  // Wessen Darts stehen gerade in den Kacheln? Eine Liste, eine Zeichnung -
  // damit die Anzeige nicht zwei Wege kennen muss.
  const liste = zustand.fremde || zustand.darts;
  const box = el("board-darts-501");
  if (box) {
    // NUR die drei Wurffelder. Das vierte traegt dieselbe Klasse, ist aber
    // die Summe - ohne diesen Ausschluss ueberschreibt die Schleife seinen
    // Inhalt und damit das Element, in das die Summe geschrieben wird.
    box.querySelectorAll(".board-dart:not(.is-total)").forEach((feld, i) => {
      const dart = liste[i];
      feld.dataset.state = dart ? dart.quelle : "leer";
      // Waehrend fremde Darts liegen, ist keine Auswahl moeglich - es gibt
      // nichts zu korrigieren, was einem gehoert.
      feld.classList.toggle("is-selected", !zustand.fremde && zustand.gewaehlt === i);
      if (!feld.dataset.verdrahtet) {
        feld.dataset.verdrahtet = "1";
        feld.addEventListener("click", () => boardSelect501(i));
      }
      feld.innerHTML = dart
        ? `<span>${dart.label}</span><small>${dart.points}</small>`
        : "<span>–</span>";
    });
  }

  const summe = liste.reduce((a, d) => a + d.points, 0);
  const sum = el("board-sum-501");
  if (sum) sum.textContent = String(summe);
}

/** Darts eines anderen Werfers anzeigen (Bot). `null` gibt die Kacheln frei.
 *
 *  Reine Anzeige: Sie wandern NICHT in den Eingabepuffer und werden nicht
 *  abgeschickt. Der Bot reicht seine Summe wie bisher ueber submit501Score
 *  ein - hier geht es nur darum, dass man ihm beim Werfen zusehen kann. */
function boardBotDarts(darts) {
  zustand.fremde = Array.isArray(darts) && darts.length ? darts.slice() : null;
  if (zustand.fremde) zustand.gewaehlt = null;
  zeichnen();
}

function treffer(t) {
  // Solange der Bot wirft, gehoeren die Kacheln ihm. Ohne diese Zeile
  // koennte man ihm waehrend seines Zuges Darts dazwischenwerfen - der
  // Ziffernblock war dafuer laengst gesperrt, das Board nicht.
  if (zustand.fremde) return;
  // Alpha-Befund 13.08.2026: Online liess sich die Boardeingabe auch
  // fuellen, waehrend der GEGNER am Zug war - Ziffernblock und Rechner
  // sind laengst gesperrt (append501Input usw.), nur dieser Weg nicht.
  // Dieselbe Bremse, dieselbe Bedingung, an der EINEN Sammelstelle:
  // Boardklick, Miss-Knopf und Trackertreffer laufen alle hier durch.
  if (!window.isLocal501 && !window.isMyTurn) return;
  // Wertet der Tracker, ist das Board reine Anzeige (game-501.js,
  // aktualisiere501Eingabe). Ein Klick darauf duerfte keinen vierten Dart
  // erfinden. pointer-events in der CSS verhindert ihn bereits - diese
  // Zeile ist die Sperre, die auch ohne CSS haelt, denn sie sitzt an der
  // EINEN Sammelstelle. Trackertreffer (quelle "erkannt") gehen bewusst
  // durch: Sie sind ja genau das, was hier gezeigt werden soll.
  if (t.quelle !== "erkannt" && window.trackerWertet501?.()) return;
  // Ist ein Dart ausgewaehlt, wird DIESER ersetzt. Das loest "Dart zurueck"
  // ab: Statt rueckwaerts zu loeschen tippt man den falschen Dart an und
  // wirft ihn neu - ein Griff statt zwei, und der Rest der Aufnahme bleibt.
  if (zustand.gewaehlt !== null) {
    const i = zustand.gewaehlt;
    zustand.darts[i] = t;
    zustand.gewaehlt = null;
    neuZeichnenBoard();
    zeichnen();
    return;
  }
  if (zustand.darts.length >= SLOTS) return;
  zustand.darts.push(t);
  neuZeichnenBoard();
  zeichnen();
}

/** Marker neu setzen, damit sie zu den Darts passen (nach einer Korrektur). */
function neuZeichnenBoard() {
  if (!zustand.board) return;
  zustand.board.clear();
  for (const d of zustand.darts) {
    if (d.xMm !== null && d.yMm !== null) {
      zustand.board.mark(d.xMm, d.yMm, d.label, d.quelle);
    }
  }
}

/** Dart zum Aendern auswaehlen - oder Auswahl aufheben. */
function boardSelect501(i) {
  zustand.gewaehlt = zustand.gewaehlt === i ? null : i;
  zeichnen();
}

function boardMiss501() {
  treffer({ points: 0, base: 0, multiplier: 0, label: "MISS", ring: "miss",
            xMm: null, yMm: null, quelle: "hand" });
}

async function boardCommit501() {
  if (!zustand.darts.length) return;
  const summe = zustand.darts.reduce((a, d) => a + d.points, 0);
  const wuerfe = zustand.darts.slice();
  // REIHENFOLGE wie beim Auto-Scoring (Befund 09.08.2026): Erst entscheidet
  // das Spiel, DANN wird geleert. Vorher stand boardReset501() vor dem
  // submit - lehnte das Spiel ab (Gegner am Zug), waren die drei Darts
  // kommentarlos weg. Derselbe Einstieg wie beim Ziffernblock - keine
  // zweite Spiellogik.
  if (typeof window.submit501Score !== "function") return;
  // Dartliste mitgeben (29.08.2026): Daraus prueft submit501Score die
  // Finish-Regel und zaehlt die echte Dartzahl fuer die Statistik.
  const angenommen = await window.submit501Score(summe, { darts: wuerfe });
  if (angenommen === false) {
    // Stehen lassen: Der Spieler sieht seine Darts weiterhin und kann sie
    // nach dem Zugwechsel erneut bestaetigen.
    zeichnen();
    return;
  }
  boardReset501();
  window.dispatchEvent(new CustomEvent("secure-darts:aufnahme", { detail: { summe, wuerfe } }));
}

/** Summe der Darts, die in dieser Aufnahme schon LIEGEN, aber noch nicht
 *  gewertet sind.
 *
 *  Gebraucht von game-501.js (eigenerRest501) fuer den OBS-Zoom: Der zeigt
 *  sonst erst nach dem Bestaetigen auf das Doppel, also genau dann nicht,
 *  wenn der Spieler darauf wirft.
 *
 *  FREMDE Darts zaehlen NICHT mit. Sie gehoeren dem Bot, nicht dem Spieler
 *  vor dieser Kamera - und sie sind ohnehin nur Anzeige (siehe
 *  zustand.fremde). */
function boardOffeneSumme501() {
  return zustand.darts.reduce((a, d) => a + (Number(d.points) || 0), 0);
}

function boardReset501() {
  zustand.darts = [];
  zustand.gewaehlt = null;
  if (zustand.board) zustand.board.clear();
  zeichnen();
}

/** Live erkannte, noch ungewertete Darts des Trackers anzeigen.
 *
 * Aufgerufen aus autoscore.js bei jeder "live"-Nachricht. Zeichnet nur
 * die Live-Ebene des Boards neu (dartboard.js, setLive) - die drei
 * Wurf-Slots und die bestaetigten Marken bleiben unberuehrt. Eine leere
 * Liste entfernt die Punkte (Dart wurde gewertet oder Erkennung weg). */
function boardLiveDarts501(darts) {
  if (!zustand.board || typeof zustand.board.setLive !== "function") return;
  zustand.board.setLive(darts);
}

/** Endgueltig erkannten Tracker-Dart auf dem Board markieren (Anzeige).
 *
 * Der Live-Punkt (boardLiveDarts501) geht damit in den normalen Treffer
 * ueber: autoscore.js ruft das aus dem 501-Adapter bei jedem gewerteten
 * throw. Die Marke lebt NEBEN den Handeingabe-Marken auf derselben Ebene;
 * eine Handeingabe zeichnet ihre Ebene neu und wirft Tracker-Marken mit
 * weg - im Auto-Scoring-Betrieb klickt aber niemand aufs Board, und beim
 * Ziehen der Pfeile (boardTrackerGeleert501) wird ohnehin aufgeraeumt. */
function boardTrackerMark501(xMm, yMm, label) {
  if (!zustand.board) return;
  if (!Number.isFinite(xMm) || !Number.isFinite(yMm)) return;
  zustand.board.mark(xMm, yMm, label || "", "erkannt");
}

/** Board geleert (Tracker-"cleared"): Marken und Live-Punkte aufraeumen.
 *  Die Marken der HANDEINGABE bleiben - sie gehoeren zu den Slots der
 *  Boardeingabe und verschwinden erst mit deren Uebernahme. */
function boardTrackerGeleert501() {
  if (!zustand.board) return;
  zustand.board.setLive?.([]);
  // clear() wirft alles weg - danach die Handeingabe-Darts neu zeichnen.
  zustand.board.clear();
  neuZeichnenBoard();
}

/** Treffer vom Kamera-Tracker. Millimeter in derselben Konvention wie board.yaml. */
function boardTrackerHit(xMm, yMm) {
  if (!zustand.board || typeof window.scoreAt !== "function") return;
  // Kein eigenes mark() - treffer() zeichnet nach der Pruefung neu.
  treffer({ ...window.scoreAt(xMm, yMm), xMm, yMm, quelle: "erkannt" });
}

// ---------------------------------------------------------------------------
// Restpunkte in die Spielerspalten spiegeln
//
// Der Punktstand wird an einem guten Dutzend Stellen in game-501.js gesetzt.
// Ihn dort ueberall zusaetzlich in die neue Anzeige zu schreiben, hiesse eine
// zweite Quelle zu pflegen - und genau daraus entstehen Staende, die
// auseinanderlaufen. Stattdessen wird der vorhandene Wert beobachtet und
// gespiegelt. Eine Quelle, zwei Anzeigen.
// ---------------------------------------------------------------------------
function spiegelRest() {
  for (const n of [1, 2]) {
    const quelle = document.getElementById(`p${n}-score`);
    const ziel = document.getElementById(`player-rest-p${n}`);
    if (!quelle || !ziel) continue;
    ziel.textContent = quelle.textContent.trim() || "–";
    if (!quelle.dataset.gespiegelt) {
      quelle.dataset.gespiegelt = "1";
      new MutationObserver(() => {
        ziel.textContent = quelle.textContent.trim() || "–";
      }).observe(quelle, { childList: true, characterData: true, subtree: true });
    }
  }
}

// ---------------------------------------------------------------------------
// Detailzeilen aus der Kopfleiste in die Spielerspalten verschieben
//
// Legs, Averages, Dartzahl und letzter Wurf standen mittig - also weit weg
// von dem Spieler, zu dem sie gehoeren. Zusammen mit dem Punktstand, der
// jetzt in den Spalten steht, war die Kopfleiste 116 px hoch und hat dem
// Board unten die Flaeche genommen.
//
// Wichtig: Die Elemente werden VERSCHOBEN, nicht nachgebaut. Ihre IDs
// wandern mit, und damit schreibt game-501.js unveraendert weiter hinein.
// Ein Nachbau waere eine zweite Quelle - dieselbe Falle wie beim Punktstand.
// ---------------------------------------------------------------------------
function verlagereDetails() {
  for (const n of [1, 2]) {
    const panel = document.getElementById(`side-history-panel-p${n}`);
    const titel = panel?.querySelector(".player-list-title");
    if (!panel || !titel || panel.dataset.verlagert) continue;

    const teile = [
      document.getElementById(`p${n}-legs-display`)?.parentElement,
      panel.ownerDocument.getElementById(`p${n}-match-avg`)?.closest(".score-avg"),
      document.getElementById(`p${n}-darts`),
      document.getElementById(`p${n}-checkout`),
      document.getElementById(`p${n}-last-throw`)?.parentElement,
    ].filter(Boolean);

    if (!teile.length) continue;
    const kasten = document.createElement("div");
    kasten.className = "player-details";
    teile.forEach((t) => kasten.appendChild(t));
    titel.before(kasten);
    panel.dataset.verlagert = "1";
  }
}

// ---------------------------------------------------------------------------
// Aktiver Spieler: kleiner Punkt neben dem Namen
//
// Die Information steht schon in #input-display-501 ("Anna wirft ..."), wird
// dort aber als breites Banner angezeigt. Statt eine zweite Quelle zu bauen,
// wird der vorhandene Text gelesen und auf den Punkt abgebildet. Das Banner
// selbst ist nur noch ausgeblendet, nicht entfernt - game-501.js schreibt
// weiter hinein.
// ---------------------------------------------------------------------------
function aktivenSpielerZeigen() {
  const quelle = document.getElementById("input-display-501");
  if (!quelle) return;
  const setzen = () => {
    const text = quelle.textContent || "";
    for (const n of [1, 2]) {
      const name = document.getElementById(`history-p${n}-name`)?.textContent.trim();
      const punkt = document.getElementById(`turn-dot-p${n}`);
      if (punkt) punkt.classList.toggle("is-active", !!name && text.includes(name));
    }
  };
  setzen();
  if (!quelle.dataset.beobachtet) {
    quelle.dataset.beobachtet = "1";
    new MutationObserver(setzen).observe(quelle, {
      childList: true, characterData: true, subtree: true,
    });
  }
}

function initBoard501() {
  const ziel = el("dartboard-501");
  if (!ziel || zustand.board) return;
  if (typeof window.createDartboard !== "function") return;
  zustand.board = window.createDartboard(ziel, { onThrow: treffer });
  spiegelRest();
  verlagereDetails();
  aktivenSpielerZeigen();
  zeichnen();
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBoard501);
  } else {
    initBoard501();
  }
}

Object.assign(window, {
  initBoard501,
  verlagereDetails,
  spiegelRest,
  boardSelect501,
  aktivenSpielerZeigen,
  boardMiss501,
  boardCommit501,
  boardReset501,
  boardOffeneSumme501,
  boardTrackerHit,
  boardLiveDarts501,
  boardTrackerMark501,
  boardTrackerGeleert501,
  boardBotDarts,
});

export {
  initBoard501,
  boardCommit501,
  boardReset501,
  boardOffeneSumme501,
  boardTrackerHit,
};
